<template>
    <div>
        <div class="facetas" id="facetas">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6 facetas__content wow animate__animated animate__fadeInLeft">
                        <div class="facetas__label">
                            <span class="facetas__label-line"></span>
                            <span class="facetas__label-text">Especialidade</span>
                        </div>
                        <h2 class="facetas__title">
                            Facetas de<br>
                            <em>Resina Composta</em>
                        </h2>
                        <h3 class="facetas__subtitle">Reabilitação Minimamente Invasiva</h3>
                        <p>
                            As facetas de resina é um dos procedimentos mais
                            buscados atualmente por quem deseja transformar o
                            sorriso sem desgaste ou com o mínimo de desgaste
                            dental possível e de forma rápida.
                        </p>
                        <p>
                            Esse procedimento requer muita habilidade manual do
                            cirurgião dentista para que a estética seja
                            devolvida de forma natural e harmônica com o rosto
                            do paciente.
                        </p>
                        <p>
                            Normalmente as facetas de resina são realizadas em
                            sessão única e em casos em que não há desgaste é
                            considerado um procedimento reversível e indolor.
                        </p>
                    </div>
                    <div class="col-12 col-lg-5 offset-lg-1 wow animate__animated animate__fadeInRight">
                        <div class="facetas__image-wrapper">
                            <img
                                src="@/assets/img/faceta.png"
                                class="facetas__image"
                                alt="Facetas de resina"
                            />
                            <div class="facetas__image-border"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="parallax-divider">
            <div class="parallax-divider__overlay"></div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style src="./style.scss" lang="scss" scoped/>
